import isArray from "lodash/isArray";
import { QueryParameter } from "@idw-types/common";

export const generateQueryParameters = (params: { [key: string]: string | Array<string> }): Array<QueryParameter> => {
    const queryParameters: Array<QueryParameter> = [];

    Object.keys(params).forEach(key => {
        if (params[key] && isArray(params[key])) {
            if (params[key].length > 0) {
                queryParameters.push({ parameter: key, value: (params[key] as Array<string>).join(",") });
            }
        } else if (params[key]) {
            queryParameters.push({ parameter: key, value: params[key] as string });
        }
    });

    return queryParameters;
};